import { Controller } from '@hotwired/stimulus'
import { formatEuro } from '../helpers/currency'

export default class extends Controller {
  static targets = ['amount', 'rate', 'amountOutput', 'fee', 'total', 'error', 'submit']
  static values = { cap: Number, rate: Number }

  connect() {
    this.recompute()
  }

  recompute() {
    const amount = parseFloat(this.amountTarget.value) || 0
    const rate = this.hasRateTarget ? parseFloat(this.rateTarget.value) || 0 : this.rateValue
    const fee = (amount * rate) / 100
    const total = amount + fee

    if (this.hasAmountOutputTarget) this.amountOutputTarget.textContent = formatEuro(amount)
    this.feeTarget.textContent = formatEuro(fee)
    this.totalTarget.textContent = formatEuro(total)

    this.#toggleCap(rate)
  }

  #toggleCap(rate) {
    const overCap = this.hasCapValue && this.capValue > 0 && rate > this.capValue

    if (this.hasErrorTarget) this.errorTarget.classList.toggle('d-none', !overCap)
    if (this.hasSubmitTarget) this.submitTarget.disabled = overCap
  }
}
